import React from 'react';
import { AuditsTable } from '../../Agreement/Table/AgreementAuditsTable';

export default function AddendumAuditsTable() {
    return <AuditsTable statusChoiceList="addendumStatus" />;
}